import type { ReactNode } from "react";
import { SidebarCollapse } from "./SidebarCollapse";
import { SidebarDrawerHead } from "./SidebarDrawerHead";
import { SidebarNav } from "./SidebarNav";
import type { NavGroup } from "./navTypes";
import { useOpenGroups } from "./useOpenGroups";

export type { NavGroup, NavItem } from "./navTypes";

export interface SidebarProps {
  nav: NavGroup[];
  active?: string;
  onNavigate?: (id: string) => void;
  collapsed?: boolean;
  onCollapsedChange?: (collapsed: boolean) => void;
  /** Mobile drawer close button. */
  onClose?: () => void;
  brandIcon?: string;
  product?: string;
  homeHref?: string;
  onHome?: () => void;
  /** Shown in the box at the bottom, next to the collapse button (e.g. the organization switcher). */
  footer?: ReactNode;
}

export function Sidebar({
  nav,
  active,
  onNavigate,
  collapsed = false,
  onCollapsedChange,
  onClose,
  brandIcon,
  product = "suite",
  homeHref = "/",
  onHome,
  footer,
}: SidebarProps): React.JSX.Element {
  const openGroups = useOpenGroups(nav, active);

  return (
    <>
      <aside className={`nb-sidebar${collapsed ? " is-collapsed" : ""}`} aria-label="Navigation">
        <SidebarDrawerHead brandIcon={brandIcon} product={product} homeHref={homeHref} onHome={onHome} onClose={onClose} />
        <SidebarNav nav={nav} active={active} collapsed={collapsed} openGroups={openGroups} onNavigate={onNavigate} />
        {footer ? <div className="nb-side-foot">{footer}</div> : null}
      </aside>
      {/* On the sidebar's edge, outside the aside (which clips), so the footer row stays free. */}
      {onCollapsedChange ? <SidebarCollapse collapsed={collapsed} onCollapsedChange={onCollapsedChange} /> : null}
    </>
  );
}
